export const formatNumberDecimals = (value) => {
  if (value == null) return '0,00';
    const number = typeof value === 'string'
      ? parseFloat(value.replace(',', '.'))
      : value;
  
    return number.toLocaleString('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

export const formatNumber = (value) => {
  if (value == null) return '0,00';

    const number = typeof value === 'string'
      ? parseFloat(value.replace(',', '.'))
      : value;
  
    return number.toLocaleString('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };